<template>
  <div>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body" v-if="mode == 'new' || mode == 'edit'">
            <validationObserver ref="addDataForm" tag="form">
              <form @submit.prevent="onSubmit" @reset.prevent="onConfirmReset">
                <div class="form-group row mb-4">
                  <label class="col-form-label col-lg-2">ชื่อ</label>
                  <div class="col-lg-7">
                    <validationProvider
                      v-slot="{ errors }"
                      name="Channel Name"
                      :rules="{
                        dynamicRequired: [
                          'กรุณาระบุชื่อช่องทางการขายเป็นภาษาอังกฤษ',
                        ],
                        duplicateName: [
                          isValidate.display_name,
                          'ชื่อช่องทางการขาย ซ้ำกับข้อมูลที่อยู่ในระบบ',
                        ],
                        validateEngWithSpecialCharacters: true,
                      }"
                    >
                      <div class="input-group">
                        <input
                          id="input_displayname"
                          name="input_displayname"
                          type="text"
                          class="form-control"
                          placeholder="ชื่อช่องทางการขาย"
                          maxlength="50"
                          v-model="model.display_name.en"
                          :class="{
                            'is-invalid': errors && errors.length,
                            'is-valid':
                              !(errors && errors.length) &&
                              model.display_name.en,
                          }"
                          v-on:keyup="onValidateDisplayname($event)"
                        />
                        <span class="input-group-append">
                          <span class="input-group-text"
                            >{{ model.display_name.en.length }}/50
                          </span>
                        </span>
                      </div>
                      <div
                        v-if="errors && errors.length"
                        class="validate-invalid"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </validationProvider>
                  </div>
                </div>
                <div class="row">
                  <label class="col-form-label col-lg-2">ประเภท</label>
                  <div class="col-form-label col-lg-8">
                    <validationProvider
                      v-slot="{ errors }"
                      name="Group"
                      :rules="{ dynamicRequired: ['กรุณาระบุข้อมูล'] }"
                    >
                      <div class="row col-lg-12">
                        <b-form-radio
                          v-model="model.group"
                          name="input_group"
                          class="custom-control custom-radio custom-radio-info mb-3"
                          value="Online"
                          style="margin-right:10px;"
                          >Online</b-form-radio
                        >
                        <b-form-radio
                          v-model="model.group"
                          name="input_group"
                          class="custom-control custom-radio custom-radio-info mb-3"
                          value="Offline"
                          style="margin-right:10px;"
                          >Offline</b-form-radio
                        >
                      </div>

                      <div
                        v-if="errors && errors.length"
                        class="validate-invalid"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </validationProvider>
                  </div>
                </div>
                <div class="form-group row mb-4">
                  <label class="col-form-label col-lg-2">สถานะ</label>
                  <div class="col-form-label col-lg-8">
                    <validationProvider
                      v-slot="{ errors }"
                      name="Status"
                      :rules="{ dynamicRequired: ['กรุณาระบุข้อมูล'] }"
                    >
                      <div class="row col-lg-12">
                        <b-form-radio
                          v-model="model.status"
                          name="input_status"
                          class="custom-control custom-radio custom-radio-info mb-3"
                          value="Active"
                          style="margin-right:10px;"
                          >Active</b-form-radio
                        >
                        <b-form-radio
                          v-model="model.status"
                          name="input_status"
                          class="custom-control custom-radio custom-radio-info mb-3"
                          value="Inactive"
                          style="margin-right:10px;"
                          >Inactive</b-form-radio
                        >
                      </div>
                      <div
                        v-if="errors && errors.length"
                        class="validate-invalid"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </validationProvider>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="text-left">
                      <div class="button-items">
                        <button
                          type="button"
                          class="btn btn-secondary"
                          @click="onBack()"
                        >
                          Back
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="text-right">
                      <div class="button-items">
                        <button type="submit" class="btn btn-primary">
                          Save
                        </button>
                        <button type="reset" class="btn btn-secondary">
                          Reset
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </validationObserver>
          </div>
          <div class="card-body" v-if="mode == 'view'">
            <div class="row mb-2">
              <div class="col-sm-12">
                <div class="text-sm-right">
                  <button
                    @click="changeMode('edit')"
                    type="button"
                    class="btn btn-warning waves-effect waves-light"
                  >
                    <i class="mdi mdi-pencil label-icon"></i>
                    Edit
                  </button>
                </div>
              </div>
            </div>
            <div class="form-group row mb-4">
              <label class="col-form-label col-lg-2">ชื่อ</label>
              <label class="col-form-label col-lg-8">{{
                model.display_name.en
              }}</label>
            </div>
            <div class="form-group row mb-4">
              <label class="col-form-label col-lg-2">ประเภท</label>
              <label class="col-form-label col-lg-8">{{ model.group }}</label>
            </div>
            <div class="form-group row mb-4">
              <label class="col-form-label col-lg-2">สถานะ</label>
              <label class="col-form-label col-lg-8">{{ model.status }}</label>
            </div>
            <div class="form-group mb-4 text-left">
              <div class="button-items">
                <button
                  type="button"
                  class="btn btn-secondary"
                  @click="onBack()"
                >
                  Back
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </div>
</template>

<script>
import Vue from 'vue'
import vue2Dropzone from 'vue2-dropzone'
import DatePicker from 'vue2-datepicker'

import PageHeader from '@/components/page-header'
import appConfig from '@/app.config'
import { required, minLength, maxLength } from 'vuelidate/lib/validators'
import channelService from '@/helpers/service/channel-service'
import { eventBus } from '@/main.js'
import { StatusEnum } from '@/enum/status.enum.js'
import { TypeEnum } from '@/enum/channel.enum.js'

export default {
  page: {
    title: 'Channel',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { PageHeader },
  data() {
    return {
      id: '',
      title: 'View',
      mode: 'view',
      items: [
        {
          text: 'Home',
          href: '/',
        },
        {
          text: 'Channel',
          href: '/channels',
        },
        {
          text: 'View',
          active: true,
        },
      ],
      model: {
        id: null,
        display_name: { en: '', th: '' },
        type: TypeEnum.OFFLINE,
        status: StatusEnum.ACTIVE,
        create_info: {
          timestamp: '',
          user_id: '',
          user_name: '',
        },
        update_info: {
          timestamp: '',
          user_id: '',
          user_name: '',
        },
      },
      isValidate: {
        display_name: false,
      },
    }
  },
  created: function() {
    if (this.$route.params.id == 'new') {
      this.mode = 'new'
      this.title = 'New Channel'
      this.items[2].text = 'New'
    } else {
      this.title = 'Detail'
      this.items[2].text = 'Detail'
      this.id = this.$route.params.id
    }
    if (this.$route.query.mode) {
      this.title = 'Edit Channel'
      this.items[2].text = 'Edit'
      this.mode = this.$route.query.mode
    }
  },
  mounted: function() {
    if (this.mode !== 'new') {
      this.getDetail()
    }
  },
  methods: {
    async getDetail() {
      let result = await channelService.getChannelMasterDetailAsync(this.id)
      if (result.status === 200) {
        this.model = result.data
      } else if (
        (result.status && result.status !== 500) ||
        (result.response && result.response.status !== 500)
      ) {
        this.$utils.notification('error', result.response.data.message, 2000)
      }
    },
    changeMode(_mode) {
      if (_mode == 'edit') {
        this.mode = 'edit'
        this.title = 'Edit Channels'
        this.items[2].text = 'Edit'
        this.getDetail()
      }
    },
    async onConfirmReset() {
      await this.$utils
        .confirmAlertDisplay(
          `ต้องการ Reset หน้าจอเป็นค่าเริ่มต้นใช่หรือไม่`,
          ''
        )
        .then(result => {
          if (result) {
            if (this.mode === 'new') {
              this.model.display_name.en = ''
              this.model.status = StatusEnum.ACTIVE
              this.model.group = TypeEnum.OFFLINE
            } else {
              this.getDetail()
            }
          }
        })
    },
    onBack() {
      this.$router.push({
        path: '/channels',
      })
    },
    async onValidateDisplayname() {
      if (
        !(
          this.model.display_name.en.trim() === '' ||
          this.model.display_name.en.trim() === null ||
          this.model.display_name.en.trim() === undefined
        )
      ) {
        let params = new URLSearchParams()
        params.append('name', this.model.display_name.en.trim())
        if (this.mode === 'edit') {
          params.append('id', this.id)
        }
        let result = await channelService.headChannelMasterAsync(params)
        if (result.status === 200) {
          this.isValidate.display_name = true
        } else if (
          (result.status && result.status === 404) ||
          (result.response.status && result.response.status === 404)
        ) {
          this.isValidate.display_name = false
        } else if (
          (result.status && result.status !== 500) ||
          (result.response && result.response.status !== 500)
        ) {
          if (result.response.data.message) {
            this.$utils.notification(
              'error',
              result.response.data.message,
              2000
            )
          } else {
            this.$utils.notification('error', 'Bad request: Unkonw error', 2000)
          }
        }
      }
    },
    async onSubmit() {
      if (this.mode === 'new') {
        await this.onSaveCreate()
      } else {
        await this.onSave()
      }
    },
    async onSave() {
      this.$refs.addDataForm.validate().then(async response => {
        if (response) {
          this.removeLastAndFirstSpacesFromString()
          let result = await channelService.updateChannelMasterAsync(
            this.id,
            this.model
          )
          if (result.status && result.status === 204) {
            this.$utils.notification('success', 'แก้ไขข้อมูลสำเร็จ', 1500)
            this.$router.push({
              path: '/channels',
            })
          } else if (
            (result.status && result.status !== 500) ||
            (result.response && result.response.status !== 500)
          ) {
            this.$utils.notification(
              'error',
              result.response.data.message,
              2000
            )
          }
        }
      })
    },
    async onSaveCreate() {
      this.$refs.addDataForm.validate().then(async response => {
        if (response) {
          this.removeLastAndFirstSpacesFromString()
          let result = await channelService.createChannelMasterAsync(this.model)
          if (result.status === 201) {
            this.$utils.notification('success', 'เพิ่มข้อมูลสำเร็จ', 1500)
            this.$router.push({
              path: '/channels',
            })
          } else if (
            (result.status && result.status !== 500) ||
            (result.response && result.response.status !== 500)
          ) {
            this.$utils.notification(
              'error',
              result.response.data.message,
              2000
            )
          }
        }
      })
    },
    removeLastAndFirstSpacesFromString() {
      this.model.display_name.en = this.model.display_name.en.trim()
    },
  },
}
</script>
